import { Trans } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";
import { useId } from "react";

import { SELLER } from "@/features/legal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/shared/ui/accordion";

const linkClassName = "text-accent hover:text-accent-strong";

// Частые вопросы об оплате: отключение автоплатежа, возврат, конец Pro.
export const PricingFaq = () => {
  const headingId = useId();
  const email = (
    <a href={`mailto:${SELLER.email}`} className={linkClassName}>
      {SELLER.email}
    </a>
  );
  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-1">
      <h2 id={headingId} className="mb-1 font-display text-[26px]">
        <Trans>Questions</Trans>
      </h2>
      <Accordion type="multiple">
        <AccordionItem value="autopay">
          <AccordionTrigger className="text-[15px] font-semibold">
            <Trans>How do I turn off autopay?</Trans>
          </AccordionTrigger>
          <AccordionContent className="text-muted">
            <Trans>
              In your Relock account, or via the link in the email the payment service sends after
              each charge. The days you have already paid for stay.
            </Trans>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="refund">
          <AccordionTrigger className="text-[15px] font-semibold">
            <Trans>Can I get my money back?</Trans>
          </AccordionTrigger>
          <AccordionContent className="text-muted">
            <Trans>
              Yes, for the unused days of Pro. Write to {email} and we will refund within 10 days
              the same way you paid. Details are in the{" "}
              <Link to="/terms" className={linkClassName}>
                offer
              </Link>
              .
            </Trans>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="ends">
          <AccordionTrigger className="text-[15px] font-semibold">
            <Trans>What happens when Pro ends?</Trans>
          </AccordionTrigger>
          <AccordionContent className="text-muted">
            <Trans>The free version comes back. Your analyses, drills and history stay.</Trans>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </section>
  );
};
